export const langText: any = {
    us: {
        gtm_coupon: 'Discount code',
        scoreMs: 'EcoCredits',
        btnMsgWait: 'login', // 登入
        btnMsgReissueSign: 'Make up for check-in', //'补签',
        btnMsgToday: 'Check in', //'签到',
        btnMsgDone1: 'Checked in', //'已签到',
        btnMsgDone2: 'Rechecked in', //'已补签',
        btnMsgExpire: 'Expired', //'已过期',
        dayAfter: '',
        today: 'Today',
        day1: 'Mon',
        day2: 'Tue',
        day3: 'Wed',
        day4: 'Thu',
        day5: 'Fri',
        day6: 'Sat',
        day7: 'Sun',

        // 没有登录时的提示语
        noLoginTips1: 'Please ',
        noLoginTipsLink1: ' log in ',
        noLoginTips2: ' before check-in.',
        noLoginTipsLink2: 'Check-in Rules', //'打卡细则',

        // 已登录时的提示语
        loginScore1: 'EcoCredits Claimed: ',

        // 签到成功，再签到X天，就能获XX积分了
        pointTipsA1: 'Check-in successful! Check in for another ',
        pointTipsA2: ' days for ',
        pointTipsA3: ' EcoCredits!',

        // 积分不够
        pointTipsB1: 'Insufficient EcoCredits! Find out how to earn more.',

        // code的提示语
        code2452: '', //'今天已打过卡了',
        code2453: '', //'重复点击打卡按钮',
        code2454: '', //'如果补签消耗的积分不够',
        code2455: 'Make-up check-in failed. You have reached the maximum number of make-up check-ins.', //'补签失败，你已达最大补签次数。',
        code2457: 'You have reached the maximum EcoCredits availeble. Thank you for participating!', //'你已达可获取的积分上限值，感谢你的参与。',
        codeFail: 'Make-up check-in failed. Please try again or contact us.', //'补签失败，请重新尝试或Contact Us。',

        // 你已连续打卡a天，恭喜你获得X积分。
        successLongA1: 'You have checked in consecutively for ',
        successLongA2: ' days. Congratulations on earning ',
        successLongA3: ' EcoCredits.', // 您获得了 xx 积分！
        // 你已打卡a天，恭喜你获得X积分。
        successLongB1: 'You have checked in for ',
        successLongB2: ' days. Congratulations on earning ',
        // 你已达可获取的积分上限值，感谢你的参与。
        successLongC2: 'You have reached the maximum EcoCredits availeble. Thank you for participating!',
        // 你已达可获取的优惠券上限值，感谢你的参与。
        successLongC3: 'You have reached the maximum coupons available. Thank you for participating!',
        // 补签成功，恭喜你获得XX积分。
        successSortA1: 'Make-up check-in successful! Congratulations on earning ',
        // 签到成功，恭喜你获得XX积分。
        successSortB1: 'Check-in successful! Congratulations on earning ', // 恭喜
        // 签到成功。
        successSortC: 'Check-in successful!',
        // 暂未到签到时间
        errorTime: 'Check-in not available.',

        // 优惠券弹窗按钮
        couponBtn: 'My Rewards',
        Redeemed: 'Redeemed',
        Issued: 'Issued',

        // 优惠券提示
        couponTipsA1: 'Check-in successful! Check in for another ',
        couponTipsA2: ' days for ',
        couponTipsA3: ' coupon!',

        couponTipsB1: 'Check-in successful! Check in for another ',
        couponTipsB2: ' days for ',
        couponTipsB3: ' coupon!',

        couponTipsC1: 'Congratulations on earning ',
        couponTipsC2: ' coupon.',
        couponTipsC3: '',

        // 错误提示
        code2466: 'Failed, please try again or Contact Us.',
        errorTipsA2: '',

        errorTipsB1: '',
        errorTipsB2: '',

        // 已打卡多少天
        hasCheckDayTips1: 'Checked in for ',
        hasCheckDayTips2: ' days.',
        //补签失败提示
        errorCheckTips: 'Make-up check-in failed. You can do make-up check-in once every 24 hours.',

        no_coupon_note: 'No rewards redeemed yet.',

        ShopNow: 'Shop Now',

        copy_success1: 'You have copied the code, please go to the store to use it.',

        Close: 'Close',
    },
    jp: {
        gtm_coupon: 'ディスカウントコード',
        scoreMs: 'ポイント',
        btnMsgWait: 'サインイン', // 登入
        btnMsgReissueSign: '再チェックイン', //'补签',
        btnMsgToday: 'ゲット', //'签到',
        btnMsgDone1: 'ゲット済', //'已签到',
        btnMsgDone2: '再署名されました', //'已补签',
        btnMsgExpire: '期限切れ', //'已过期',
        dayAfter: '(日)',
        today: '今日',
        day1: '(月)',
        day2: '(火)',
        day3: '(水)',
        day4: '(木)',
        day5: '(金)',
        day6: '(土)',
        day7: '(日)',

        // 没有登录时的提示语
        noLoginTips1: 'チェックイン前に',
        noLoginTipsLink1: 'ログイン',
        noLoginTips2: 'してください。',
        noLoginTipsLink2: 'ルール', //'打卡细则',

        // 已登录时的提示语
        loginScore1: '獲得ポイント：',

        // 签到成功，再签到X天，就能获XX积分了
        pointTipsA1: 'チェックインに成功！',
        pointTipsA2: ' EcoCredits でさらに ',
        pointTipsA3: ' 日間チェックイン！',

        // 积分不够
        pointTipsB1: 'エコポイントが不十分です！ポイント増加の方法を調べてください。',

        // code的提示语
        code2452: '今日はチェックイン済みです', //'今天已打过卡了',
        code2453: 'カードを押すボタンを繰り返しクリック', //'重复点击打卡按钮',
        code2454: '再発行で消費するポイントが足りなければ', //'如果补签消耗的积分不够',
        code2455: '再チェックインに失敗しました。再チェックインの最大回数に達しました。', //'补签失败，你已达最大补签次数。',
        code2457: '獲得できる最大ポイントに達しました。ご参加いただきありがとうございます。', //'你已达可获取的积分上限值，感谢你的参与。',
        codeFail: 'チェックインに失敗しました。もう一度お試しいただくか、お問い合わせください。', //'补签失败，请重新尝试或Contact Us。',

        // 你已连续打卡a天，恭喜你获得X积分。
        successLongA1: '',
        successLongA2: '日連続でチェックインしましたので、 ',
        successLongA3: ' ポイントを獲得しました！', // 您获得了 xx 积分！
        // 你已打卡a天，恭喜你获得X积分。
        successLongB1: '',
        successLongB2: '日間チェックインしましたので、 ',
        // 你已达可获取的积分上限值，感谢你的参与。
        successLongC2: '獲得できる最大ポイントに達しました。ご参加いただきありがとうございます。',
        // 你已达可获取的优惠券上限值，感谢你的参与。
        successLongC3: '獲得できるクーポンの上限に達しました。ご参加いただきありがとうございます。',
        // 补签成功，恭喜你获得XX积分。
        successSortA1: 'おめでとうございます！再チェックインに成功したので、',
        // 签到成功，恭喜你获得XX积分。
        successSortB1: 'おめでとうございます！', // 恭喜
        // 签到成功。
        successSortC: 'チェックインに成功しました！',
        // 暂未到签到时间
        errorTime: 'チェックインできません。',

        // 优惠券弹窗按钮
        couponBtn: '保有する特典',
        Redeemed: 'Redeemed',
        Issued: 'Issued',

        // 优惠券提示
        couponTipsA1: 'チェックインに成功！',
        couponTipsA2: ' クーポンでさらに',
        couponTipsA3: ' 日間チェックイン！',

        couponTipsB1: 'チェックインに成功！',
        couponTipsB2: ' クーポンでさらに ',
        couponTipsB3: ' 日間チェックイン！',

        couponTipsC1: '',
        couponTipsC2: ' クーポン獲得おめでとうございます。',
        couponTipsC3: '',

        // 错误提示
        code2466: 'コードをコピーしました。ストアにアクセスして使用してください。',
        errorTipsA2: '',

        errorTipsB1: '',
        errorTipsB2: '',

        // 已打卡多少天
        hasCheckDayTips1: '',
        hasCheckDayTips2: ' 日間チェックインしました。',
        //补签失败提示
        errorCheckTips: 'メイクアップチェックインは24時間に1回行うことができます。',

        no_coupon_note: 'まだ交換済みの特典はありません。',

        ShopNow: '今すぐ購入',

        copy_success1: 'コードをコピーしました。ストアにアクセスして使用してください。',

        Close: '閉じる',
    },
    de: {
        gtm_coupon: 'Coupon',
        scoreMs: 'EcoCredits',
        btnMsgWait: 'anmelden', // 登入
        btnMsgReissueSign: 'Check-in nachholen', //'补签',
        btnMsgToday: 'Check-in', //'签到',
        btnMsgDone1: 'Eingecheckt', //'已签到',
        btnMsgDone2: 'Eingecheckt', //'已补签',
        btnMsgExpire: 'Abgelaufen', //'已过期',
        dayAfter: '',
        today: 'Heute',
        day1: 'Mo',
        day2: 'Di',
        day3: 'Mi',
        day4: 'Do',
        day5: 'Fr',
        day6: 'Sa',
        day7: 'So',

        // 没有登录时的提示语
        noLoginTips1: 'Bitte ',
        noLoginTipsLink1: ' melden Sie sich ',
        noLoginTips2: ' vor dem Einchecken an.',
        noLoginTipsLink2: 'Regeln für den Check-in', //'打卡细则',

        // 已登录时的提示语
        loginScore1: 'In Anspruch genommene EcoCredits: ',

        // 签到成功，再签到X天，就能获XX积分了
        pointTipsA1: 'Erfolgreich eingecheckt! Checken Sie für weitere ',
        pointTipsA2: ' Tage für ',
        pointTipsA3: ' EcoCredits ein!',

        // 积分不够
        pointTipsB1: 'Nicht genügend EcoCredits! Hier erfahren Sie, wie Sie mehr sammeln können.',

        // code的提示语
        code2452: '', //'今天已打过卡了',
        code2453: '', //'重复点击打卡按钮',
        code2454: '', //'如果补签消耗的积分不够',
        code2455: 'Wiederherstellungs-Check-in fehlgeschlagen. Sie haben die maximal mögliche Anzahl von Wiederherstellungs-Check-ins erreicht.', //'补签失败，你已达最大补签次数。',
        code2457: 'Sie haben die maximal mögliche Anzahl an EcoCredits erreicht. Vielen Dank für Ihre Teilnahme!', //'你已达可获取的积分上限值，感谢你的参与。',
        codeFail: 'Wiederherstellungs-Check-in fehlgeschlagen. Bitte versuchen Sie es erneut oder kontaktieren Sie uns.', //'补签失败，请重新尝试或Contact Us。',

        // 你已连续打卡a天，恭喜你获得X积分。
        successLongA1: 'Sie haben hintereinander für',
        successLongA2: ' Tage eingecheckt. Herzlichen Glückwunsch! Sie haben ',
        successLongA3: ' EcoCredits gesammelt.', // 您获得了 xx 积分！
        // 你已打卡a天，恭喜你获得X积分。
        successLongB1: 'Sie haben für ',
        successLongB2: ' Tage eingecheckt. Herzlichen Glückwunsch! Sie haben ',
        // 你已达可获取的积分上限值，感谢你的参与。
        successLongC2: 'Sie haben die maximal mögliche Anzahl an EcoCredits erreicht. Vielen Dank für Ihre Teilnahme!',
        successLongC3: 'Sie haben die maximal verfügbare Anzahl an Coupons erreicht. Vielen Dank für Ihre Teilnahme!',
        // 补签成功，恭喜你获得XX积分。
        successSortA1: 'Wiederherstellungs-Check-in erfolgreich! Herzlichen Glückwunsch! Sie haben ',
        // 签到成功，恭喜你获得XX积分。
        successSortB1: 'Check-in erfolgreich Herzlichen Glückwunsch! Sie haben ', // 恭喜
        // 签到成功。
        successSortC: 'Check-in erfolgreich',
        // 暂未到签到时间
        errorTime: 'Check-in zur Zeit nicht verfügbar.',

        // 优惠券弹窗按钮
        couponBtn: 'Meine Prämien',
        Redeemed: 'Redeemed',
        Issued: 'Issued',

        // 优惠券提示
        couponTipsA1: 'Erfolgreich eingecheckt! Checken Sie für weitere ',
        couponTipsA2: ' Tage für den ',
        couponTipsA3: ' Gutschein ein!',

        couponTipsB1: 'Erfolgreich eingecheckt! Checken Sie für weitere ',
        couponTipsB2: ' Tage für den ',
        couponTipsB3: ' Gutschein ein!',

        couponTipsC1: 'Herzlichen Glückwunsch! Sie haben ',
        couponTipsC2: ' EcoCredits gesammelt.',
        couponTipsC3: '',

        // 错误提示
        code2466: 'Fehlgeschlagen. Bitte versuchen Sie es erneut oder kontaktieren Sie uns.',
        errorTipsA2: '',

        errorTipsB1: '',
        errorTipsB2: '',

        // 已打卡多少天
        hasCheckDayTips1: 'Sie haben für ',
        hasCheckDayTips2: ' Tage eingecheckt.',

        //补签失败提示
        errorCheckTips: 'Wiederherstellungs-Check-in fehlgeschlagen. Sie können es nur einmal innerhalb von 24 Std. versuchen.',

        no_coupon_note: 'Noch keine Gutscheine eingelöst.',

        ShopNow: 'Jetzt kaufen',

        copy_success1: 'Sie haben den Code kopiert. Bitte gehen Sie zum Shop, um ihn einzulösen.',

        Close: 'Schließen',
    },
    fr: {
        gtm_coupon: 'Code de réduction',
        scoreMs: 'EcoCredits',
        btnMsgWait: 'se connecter', // 登入
        btnMsgReissueSign: 'Rattraper', //'补签',
        btnMsgToday: 'Confirmer', //'签到',
        btnMsgDone1: 'Obtenu', //'已签到',
        btnMsgDone2: 'Obtenu', //'已补签',
        btnMsgExpire: 'Arrivé à expiration', //'已过期',
        dayAfter: '',
        today: "Aujourd'hui",
        day1: 'lun.',
        day2: 'mar.',
        day3: 'mer.',
        day4: 'jeu.',
        day5: 'ven.',
        day6: 'sam.',
        day7: 'dim.',

        // 没有登录时的提示语
        noLoginTips1: "Pour bénéficier des récompenses, veuillez d'abord vous ",
        noLoginTipsLink1: 'connecter',
        noLoginTips2: ' à votre compte.',
        noLoginTipsLink2: "Règles de l'événement", //'打卡细则',

        // 已登录时的提示语
        loginScore1: 'EcoCredits gagnés: ',

        // 签到成功，再签到X天，就能获XX积分了
        pointTipsA1: 'Confirmation réussie ! Participez pendant ',
        pointTipsA2: ' jours supplémentaires pour obtenir ',
        pointTipsA3: ' EcoCredits !',

        // 积分不够
        pointTipsB1: `Vous n'avez pas assez d'EcoCredits ! Découvrez comment en gagner plus.`,

        // code的提示语
        code2452: '', //'今天已打过卡了',
        code2453: '', //'重复点击打卡按钮',
        code2454: '', //'如果补签消耗的积分不够',
        code2455: 'Make-up check-in failed. You have reached the maximum number of make-up check-ins.', // 补签失败，你已达最大补签次数。
        code2457: "Vous avez atteint le maximum d'EcoCredits disponibles. Merci de votre participation !", // 你已达可获取的积分上限值，感谢你的参与。
        codeFail: 'La confirmation de présence a échoué. Veuillez réessayer ou contactez-nous.', // 补签失败，请重新尝试或Contact Us。

        // 你已连续打卡a天，恭喜你获得X积分。
        successLongA1: 'Vous avez confirmé votre présence consécutivement pendant ',
        successLongA2: ' jours. Félicitations, vous avez gagné ',
        successLongA3: ' EcoCredits.', // 您获得了 xx 积分！
        // 你已打卡a天，恭喜你获得X积分。
        successLongB1: 'Vous avez confirmé votre présence pendant ',
        successLongB2: ' jours. Félicitations, vous avez gagné ',
        // 你已达可获取的积分上限值，感谢你的参与。
        successLongC2: "Vous avez atteint le maximum d'EcoCredits disponibles. Merci de votre participation !",
        successLongC3: 'Vous avez atteint le nombre maximum de coupons disponibles. Merci de votre participation !',
        // 补签成功，恭喜你获得XX积分。
        successSortA1: 'Confirmation réussie ! Félicitations, vous avez gagné ',
        // 签到成功，恭喜你获得XX积分。
        successSortB1: 'Confirmation réussie ! Félicitations, vous avez gagné ', // 恭喜
        // 签到成功。
        successSortC: 'Confirmation réussie !',
        // 暂未到签到时间
        errorTime: 'Confirmation non disponible.',

        // 优惠券弹窗按钮
        couponBtn: 'Mes récompenses',
        Redeemed: 'Redeemed',
        Issued: 'Issued',

        // 优惠券提示
        couponTipsA1: 'Confirmation réussie ! Participez pendant ',
        couponTipsA2: ' jours supplémentaires pour obtenir un coupon ',
        couponTipsA3: ' !',

        couponTipsB1: 'Confirmation réussie ! Participez pendant ',
        couponTipsB2: ' jours supplémentaires pour obtenir un coupon ',
        couponTipsB3: ' !',

        couponTipsC1: 'Félicitations, vous avez gagné un coupon ',
        couponTipsC2: '.',
        couponTipsC3: '',

        // 错误提示
        code2466: `Vous avez copié le code, rendez-vous sur la boutique pour l'utiliser.`,
        errorTipsA2: '',

        errorTipsB1: '',
        errorTipsB2: '',

        // 已打卡多少天
        hasCheckDayTips1: `Vous avez participé à l'événement pendant une période de `,
        hasCheckDayTips2: ' jours consécutifs.',

        //补签失败提示
        errorCheckTips: 'Vous pouvez effectuer un enregistrement de rattrapage une fois toutes les 24 heures.',

        no_coupon_note: 'Aucune récompense échangée pour le moment.',

        ShopNow: 'Acheter',

        copy_success1: `Vous avez copié le code, rendez-vous sur la boutique pour l'utiliser.`,

        Close: 'Fermer',
    },
    es: {
        gtm_coupon: 'Código de descuento',
        scoreMs: 'EcoCredits',
        btnMsgWait: 'iniciar sesión', // 登入
        btnMsgReissueSign: 'Recuperar visitas', //'补签',
        btnMsgToday: 'Visitar', //'签到',
        btnMsgDone1: 'Visitado', //'已签到',
        btnMsgDone2: 'Visitado', //'已补签',
        btnMsgExpire: 'Caducado', //'已过期',
        dayAfter: '',
        today: 'Hoy',
        day1: 'Lun',
        day2: 'Mar',
        day3: 'Mié',
        day4: 'Jue',
        day5: 'Vie',
        day6: 'Sáb',
        day7: 'Dom',

        // 没有登录时的提示语
        noLoginTips1: 'Por favor, inicia sesión antes de ',
        noLoginTipsLink1: 'registrarte',
        noLoginTips2: '.',
        noLoginTipsLink2: 'Reglas de las visitas', //'打卡细则',

        // 已登录时的提示语 - 已获积分
        loginScore1: 'EcoCredits reclamados: ',

        // 签到成功，再签到X天，就能获XX积分了
        pointTipsA1: '¡Registro realizado correctamente! ¡Regístrate durante otros ',
        pointTipsA2: ' días para obtener ',
        pointTipsA3: ' EcoCredits!',

        // 积分不够
        pointTipsB1: '¡No hay suficientes EcoCredits! Averigua cómo obtener más.',

        // code的提示语
        code2452: '', //'今天已打过卡了',
        code2453: '', //'重复点击打卡按钮',
        code2454: '', //'如果补签消耗的积分不够',
        code2455: 'Falló la recuperación de las visitas. Has alcanzado el número máximo de recuperaciones de visitas.', //'补签失败，你已达最大补签次数。',
        code2457: 'Has conseguido el número máximo de EcoCredits disponibles. ¡Gracias por participar!', //'你已达可获取的积分上限值，感谢你的参与。',
        codeFail: 'Falló la visita. Vuelve a intentarlo o contáctanos.', //'补签失败，请重新尝试或Contact Us。',

        // 你已连续打卡a天，恭喜你获得X积分。
        successLongA1: 'Has hecho visitas de manera consecutiva durante ',
        successLongA2: ' días. Enhorabuena por haber ganado ',
        successLongA3: ' EcoCredits.', // 您获得了 xx 积分！
        // 你已打卡a天，恭喜你获得X积分。
        successLongB1: 'Has realizado visitas durante ',
        successLongB2: ' días. Enhorabuena por haber ganado ',
        // 你已达可获取的积分上限值，感谢你的参与。
        successLongC2: 'Has conseguido el número máximo de EcoCredits disponibles. ¡Gracias por participar!',
        successLongC3: 'Has conseguido el número máximo de cupones disponibles. ¡Gracias por participar!',
        // 补签成功，恭喜你获得XX积分。
        successSortA1: '¡Recuperación de visitas realizada correctamente! Enhorabuena por haber ganado ',
        // 签到成功，恭喜你获得XX积分。
        successSortB1: '¡Visita realizada correctamente! Enhorabuena por haber ganado ', // 恭喜
        // 签到成功。
        successSortC: '¡Visita realizada correctamente!',
        // 暂未到签到时间
        errorTime: 'Visita no disponible.',

        // 优惠券弹窗按钮
        couponBtn: 'Mis recompensas',
        Redeemed: 'Redeemed',
        Issued: 'Issued',

        // 优惠券提示
        couponTipsA1: '¡Registro realizado correctamente! ¡Regístrate durante otros ',
        couponTipsA2: ' días para obtener un cupón de ',
        couponTipsA3: '!',

        couponTipsB1: '¡Registro realizado correctamente! ¡Regístrate durante otros ',
        couponTipsB2: ' días para obtener un cupón de ',
        couponTipsB3: '!',

        couponTipsC1: 'Enhorabuena por haber ganado un cupón de ',
        couponTipsC2: '.',
        couponTipsC3: '',

        // 错误提示
        code2466: 'Has copiado el código; ve a la tienda para usarlo.',
        errorTipsA2: '',

        errorTipsB1: '',
        errorTipsB2: '',

        // 已打卡多少天
        hasCheckDayTips1: 'Registrado durante ',
        hasCheckDayTips2: ' días.',

        //补签失败提示
        errorCheckTips: 'Puedes hacer el registro de recuperación una vez cada 24 horas.',

        no_coupon_note: 'Todavía no se ha canjeado ninguna recompensa.',

        ShopNow: 'Comprar ahora',

        copy_success1: 'Has copiado el código; ve a la tienda para usarlo.',

        Close: 'Cerrar',
    },
    it: {
        gtm_coupon: 'Codice di sconto',
        scoreMs: 'EcoCredits',
        btnMsgWait: 'accedi', // 登入
        btnMsgReissueSign: 'Recupera un check-in', //'补签',
        btnMsgToday: 'Esegui il check-in', //'签到',
        btnMsgDone1: 'Check-in eseguito', //'已签到',
        btnMsgDone2: 'Check-in eseguito', //'已补签',
        btnMsgExpire: 'Scaduti', //'已过期',
        dayAfter: '',
        today: 'Oggi',
        day1: 'Lun',
        day2: 'Mar',
        day3: 'Mer',
        day4: 'Gio',
        day5: 'Ven',
        day6: 'Sab',
        day7: 'Dom',

        // 没有登录时的提示语
        noLoginTips1: '',
        noLoginTipsLink1: 'Accedi',
        noLoginTips2: ' prima di eseguire il check-in.',
        noLoginTipsLink2: 'Regole per l’attività Check-in', //'打卡细则',

        // 已登录时的提示语
        loginScore1: 'EcoCredits richiesti: ',

        // 签到成功，再签到X天，就能获XX积分了
        pointTipsA1: 'Check-in eseguito con successo! Effettua il check-in per altri ',
        pointTipsA2: ' giorni per guadagnare ',
        pointTipsA3: ' EcoCredits!',

        // 积分不够
        pointTipsB1: 'EcoCredits non sufficienti! Scopri come guadagnarne altri.',

        // code的提示语
        code2452: '', //'今天已打过卡了',
        code2453: '', //'重复点击打卡按钮',
        code2454: '', //'如果补签消耗的积分不够',
        code2455: 'Recupero check-in non riuscito. Hai raggiunto il numero massimo di check-in recuperabili.', //'补签失败，你已达最大补签次数。',
        code2457: 'Hai raggiunto il numero massimo di EcoCredits disponibili. Grazie per aver partecipato!', //'你已达可获取的积分上限值，感谢你的参与。',
        codeFail: 'Check-in non riuscito. Riprova o contattaci.', //'补签失败，请重新尝试或Contact Us。',

        // 你已连续打卡a天，恭喜你获得X积分。
        successLongA1: 'Hai effettuato il check-in per ',
        successLongA2: ' giorni di seguito. Congratulazioni: hai guadagnato ',
        successLongA3: ' EcoCredits.', // 您获得了 xx 积分！
        // 你已打卡a天，恭喜你获得X积分。
        successLongB1: 'Hai effettuato il check-in per ',
        successLongB2: ' giorni. Congratulazioni: hai guadagnato ',
        // 你已达可获取的积分上限值，感谢你的参与。
        successLongC2: 'Hai raggiunto il numero massimo di EcoCredits disponibili. Grazie per aver partecipato!',
        successLongC3: 'Hai raggiunto il numero massimo di coupon disponibili. Grazie per aver partecipato!',
        // 补签成功，恭喜你获得XX积分。
        successSortA1: 'Check-in recuperato con successo! Congratulazioni: hai guadagnato ',
        // 签到成功，恭喜你获得XX积分。
        successSortB1: 'Check-in eseguito con successo! Congratulazioni: hai guadagnato ', // 恭喜
        // 签到成功。
        successSortC: 'Check-in eseguito con successo!',
        // 暂未到签到时间
        errorTime: 'Check-in non disponibile',

        // 优惠券弹窗按钮
        couponBtn: 'I miei premi',
        Redeemed: 'Redeemed',
        Issued: 'Issued',

        // 优惠券提示
        couponTipsA1: 'Check-in eseguito con successo! Effettua il check-in per altri ',
        couponTipsA2: ' giorni per aggiudicarti un buono sconto da ',
        couponTipsA3: '!',

        couponTipsB1: 'Check-in eseguito con successo! Effettua il check-in per altri ',
        couponTipsB2: ' giorni per aggiudicarti un buono sconto da ',
        couponTipsB3: '!',

        couponTipsC1: 'Congratulazioni: hai guadagnato un buono sconto da ',
        couponTipsC2: '.',
        couponTipsC3: '',

        // 错误提示
        code2466: 'Hai copiato il codice, vai nel negozio per utilizzarlo.',
        errorTipsA2: '',

        errorTipsB1: '',
        errorTipsB2: '',

        // 已打卡多少天
        hasCheckDayTips1: 'Check-in eseguito per ',
        hasCheckDayTips2: ' giorni.',

        //补签失败提示
        errorCheckTips: 'Puoi fare il check-in di recupero una volta ogni 24 ore.',

        no_coupon_note: 'Nessun premio riscattato ancora.',

        ShopNow: 'Acquista ora',

        copy_success1: 'Hai copiato il codice, vai nel negozio per utilizzarlo.',

        Close: 'Chiudi',
    },
    kr: {
        gtm_coupon: '할인 쿠폰',
        scoreMs: 'EcoCredits',
        btnMsgWait: '로그인', // 登入
        btnMsgReissueSign: '체크인 보충', //'补签',
        btnMsgToday: '체크인', //'签到',
        btnMsgDone1: '체크인됨', //'已签到',
        btnMsgDone2: '체크인됨', //'已补签',
        btnMsgExpire: '만료됨', //'已过期',
        dayAfter: '',
        today: '오늘',
        day1: '월',
        day2: '화',
        day3: '수',
        day4: '목',
        day5: '금',
        day6: '토',
        day7: '일',

        // 没有登录时的提示语
        noLoginTips1: '체크인 전에 ',
        noLoginTipsLink1: '로그인',
        noLoginTips2: ' 해 주세요.',
        noLoginTipsLink2: '체크인 규칙', //'打卡细则',

        // 已登录时的提示语
        loginScore1: 'EcoCredits 청구됨: ',

        // 签到成功，再签到X天，就能获XX积分了
        pointTipsA1: '체크인 성공! ',
        pointTipsA2: ' EcoCredits로 ',
        pointTipsA3: '일 더 체크인하세요!',

        // 积分不够
        pointTipsB1: '에코포인트가 부족합니다! 더 많이 얻을 수 있는 방법을 찾아보세요.',

        // code的提示语
        code2452: '', //'今天已打过卡了',
        code2453: '', //'重复点击打卡按钮',
        code2454: '', //'如果补签消耗的积分不够',
        code2455: '체크인 보충 실패. 체크인 보충의 최대 횟수에 도달했습니다.', //'补签失败，你已达最大补签次数。',
        code2457: '사용 가능한 최대 EcoCredits에 도달했습니다. 참여해 주셔서 감사합니다!', //'你已达可获取的积分上限值，感谢你的参与。',
        codeFail: '체크인에 실패했습니다. 다시 시도하거나 당사에 문의해 주세요.', //'补签失败，请重新尝试或Contact Us。',

        // 你已连续打卡a天，恭喜你获得X积分。
        successLongA1: '',
        successLongA2: ' 일 연속 체크인했습니다. ',
        successLongA3: ' EcoCredits 획득을 축하합니다.', // 您获得了 xx 积分！
        // 你已打卡a天，恭喜你获得X积分。
        successLongB1: '',
        successLongB2: ' 일 체크인했습니다. ',
        // 你已达可获取的积分上限值，感谢你的参与。
        successLongC2: '사용 가능한 최대 EcoCredits에 도달했습니다. 참여해 주셔서 감사합니다!',
        successLongC3: '사용 가능한 쿠폰의 최대 수량에 도달했습니다. 참여해 주셔서 감사합니다!',
        // 补签成功，恭喜你获得XX积分。
        successSortA1: '체크인 보충 성공! ',
        // 签到成功，恭喜你获得XX积分。
        successSortB1: '체크인 성공! ', // 恭喜
        // 签到成功。
        successSortC: '체크인 성공!',
        // 暂未到签到时间
        errorTime: '체크인이 불가능합니다.',

        // 优惠券弹窗按钮
        couponBtn: '내 보상',
        Redeemed: 'Redeemed',
        Issued: 'Issued',

        // 优惠券提示
        couponTipsA1: '체크인 성공! ',
        couponTipsA2: ' 쿠폰으로 ',
        couponTipsA3: '일 더 체크인하세요!',

        couponTipsB1: '체크인 성공! ',
        couponTipsB2: ' 쿠폰으로 ',
        couponTipsB3: '일 더 체크인하세요!',

        couponTipsC1: '',
        couponTipsC2: ' 쿠폰을 획득하신 것을 축하드립니다.',
        couponTipsC3: '',

        // 错误提示
        code2466: '코드를 복사​했습니다. 코드를 사용하려면 스토어로 이동​하세요.',
        errorTipsA2: '',

        errorTipsB1: '',
        errorTipsB2: '',

        // 已打卡多少天
        hasCheckDayTips1: '',
        hasCheckDayTips2: '일 동안 체크인했습니다.',

        //补签失败提示
        errorCheckTips: '메이크업 체크인은 24시간에 한 번만 가능합니다.',

        no_coupon_note: '포인트 사용 내역이 없습니다.',

        ShopNow: '지금 구매하기',

        copy_success1: '코드를 복사​했습니다. 코드를 사용하려면 스토어로 이동​하세요.',

        Close: '닫기',
    },
    br: {
        gtm_coupon: 'Código de desconto',
        scoreMs: 'EcoCredits',
        btnMsgWait: 'Fazer login', // 登入
        btnMsgReissueSign: 'Recuperar o check-in', //'补签',
        btnMsgToday: 'Check-in', //'签到',
        btnMsgDone1: 'Check-in feito', //'已签到',
        btnMsgDone2: 'Check-in feito novamente', //'已补签',
        btnMsgExpire: 'Expirados', //'已过期', 空
        dayAfter: '',
        today: 'Hoje',
        day1: 'Seg',
        day2: 'Ter',
        day3: 'Qua',
        day4: 'Qui',
        day5: 'Sex',
        day6: 'Sáb',
        day7: 'Dom',

        // 没有登录时的提示语
        noLoginTips1: 'Por gentileza, ',
        noLoginTipsLink1: ' faça login ',
        noLoginTips2: ' antes do check-in ',
        noLoginTipsLink2: 'Regras de check-in', //'打卡细则',

        // 已登录时的提示语
        loginScore1: 'EcoCredits reivindicados: ',

        // 签到成功，再签到X天，就能获XX积分了
        pointTipsA1: 'Check-in feito com sucesso! Faça check-in para outros ',
        pointTipsA2: ' dias para ',
        pointTipsA3: ' EcoCredits!',

        // 积分不够
        pointTipsB1: 'EcoCredits insuficientes! Saiba como ganhar mais.',

        // code的提示语
        code2452: '', //'今天已打过卡了',
        code2453: '', //'重复点击打卡按钮',
        code2454: '', //'如果补签消耗的积分不够',
        code2455: 'Falha no check-in de compensação. Você atingiu o número máximo de check-ins de compensação.', //'补签失败，你已达最大补签次数。',
        code2457: 'Você atingiu o limite máximo de EcoCredits disponíveis. Agradecemos a participação!', //'你已达可获取的积分上限值，感谢你的参与。',
        codeFail: 'Falha no check-in de compensação. Tente novamente ou fale conosco.', //'补签失败，请重新尝试或Contact Us。',

        // 你已连续打卡a天，恭喜你获得X积分。
        successLongA1: 'Você fez check-ins consecutivamente por ',
        successLongA2: ' dias. Parabéns por ganhar ',
        successLongA3: ' EcoCredits.', // 您获得了 xx 积分！
        // 你已打卡a天，恭喜你获得X积分。
        successLongB1: 'Você fez check-ins por ',
        successLongB2: ' dias. Parabéns por ganhar ',
        // 你已达可获取的积分上限值，感谢你的参与。
        successLongC2: 'Você atingiu o limite máximo de EcoCredits disponíveis. Agradecemos a participação!',
        successLongC3: 'Você atingiu o número máximo de cupons disponíveis. Agradecemos a sua participação!',
        // 补签成功，恭喜你获得XX积分。
        successSortA1: 'Check-in complementar realizado com sucesso! Parabéns por ganhar ',
        // 签到成功，恭喜你获得XX积分。
        successSortB1: 'Check-in feito com sucesso! Parabéns por ganhar ', // 恭喜
        // 签到成功。
        successSortC: 'Check-in feito com sucesso!',
        // 暂未到签到时间
        errorTime: 'Check-in não disponível.',

        // 优惠券弹窗按钮
        couponBtn: 'Minhas recompensas',
        Redeemed: 'Resgatados',
        Issued: 'Emitidos',

        // 签到成功！再签到X天，就能获【XX】优惠券了。
        couponTipsA1: 'Check-in feito com sucesso! Faça check-in para outros ',
        couponTipsA2: ' dias para ',
        couponTipsA3: ' cupom!',

        // 补签成功！再签到X天，就能获【XX】优惠券了。
        couponTipsB1: 'Check-in feito com sucesso! Faça check-in para outros ',
        couponTipsB2: ' dias para ',
        couponTipsB3: ' cupom!',

        // 恭喜你获得【XX】优惠券。
        couponTipsC1: 'Parabéns por ganhar ',
        couponTipsC2: ' cupom.',
        couponTipsC3: '',

        // 错误提示
        code2466: 'Falha. Tente novamente ou fale conosco.', // 空
        errorTipsA2: '',

        errorTipsB1: '',
        errorTipsB2: '',

        // 已打卡多少天
        hasCheckDayTips1: 'Check-in feito por ',
        hasCheckDayTips2: ' dias.',
        // 补签失败，24h只能补签1次。
        errorCheckTips: 'Falha no check-in de compensação. Você pode fazer um check-in de compensação uma vez a cada 24 horas.',

        no_coupon_note: 'Nenhuma recompensa resgatada ainda.', // 空

        ShopNow: 'Compre agora',

        copy_success1: 'Você copiou o código. Vá até a loja para usá-lo.', // 空

        // 关闭
        Close: 'Fechar',
    },
    mx: {
        gtm_coupon: 'Código de descuento',
        scoreMs: 'EcoCréditos',
        btnMsgWait: 'iniciar sesión', // 登入
        btnMsgReissueSign: 'Recuperación de registro', //'补签',
        btnMsgToday: 'Registrarse', //'签到',
        btnMsgDone1: 'Registrado', //'已签到',
        btnMsgDone2: 'Registrado nuevamente en', //'已补签',
        btnMsgExpire: 'Caducado', //'已过期',
        dayAfter: '',
        today: 'Hoy',
        day1: 'Lu.',
        day2: 'Ma.',
        day3: 'Mi.',
        day4: 'Ju.',
        day5: 'Vi.',
        day6: 'Sá.',
        day7: 'Do.',

        // 没有登录时的提示语
        noLoginTips1: 'Por favor ',
        noLoginTipsLink1: ' iniciar sesión ',
        noLoginTips2: ' antes de registrarte.',
        noLoginTipsLink2: 'Reglas de registro', //'打卡细则',

        // 已登录时的提示语
        loginScore1: 'EcoCréditos reclamados: ',

        // 签到成功，再签到X天，就能获XX积分了
        pointTipsA1: '¡Registro exitoso! Regístrate por otros ',
        pointTipsA2: ' días para obtener ',
        pointTipsA3: ' EcoCréditos!',

        // 积分不够
        pointTipsB1: '¡EcoCréditos insuficientes! Descubre cómo ganar más.',

        // code的提示语
        code2452: '', //'今天已打过卡了',
        code2453: '', //'重复点击打卡按钮',
        code2454: '', //'如果补签消耗的积分不够',
        code2455: 'Error de registro de recuperación. Alcanzaste el máximo de registros de recuperación.', //'补签失败，你已达最大补签次数。',
        code2457: 'Alcanzaste el máximo de EcoCréditos disponible. ¡Gracias por participar!', //'你已达可获取的积分上限值，感谢你的参与。',
        codeFail: 'Error de registro de recuperación. Inténtalo de nuevo o comunícate con nosotros.', //'补签失败，请重新尝试或Contact Us。',

        // 你已连续打卡a天，恭喜你获得X积分。
        successLongA1: 'Te has registrado consecutivamente por ',
        successLongA2: ' días. Felicitaciones por obtener ',
        successLongA3: ' EcoCréditos.', // 您获得了 xx 积分！
        // 你已打卡a天，恭喜你获得X积分。
        successLongB1: 'Te has registrado por ',
        successLongB2: ' días. Felicitaciones por obtener ',
        // 你已达可获取的积分上限值，感谢你的参与。
        successLongC2: 'Alcanzaste el máximo de EcoCréditos disponible. ¡Gracias por participar!',
        successLongC3: 'Alcanzaste el número máximo de cupones disponibles. ¡Gracias por participar!',
        // 补签成功，恭喜你获得XX积分。
        successSortA1: '¡Registro de recuperación exitoso! Felicitaciones por obtener ',
        // 签到成功，恭喜你获得XX积分。
        successSortB1: '¡Registro exitoso! Felicitaciones por obtener ', // 恭喜
        // 签到成功。
        successSortC: '¡Registro exitoso!',
        // 暂未到签到时间
        errorTime: 'Registro no disponible',

        // 优惠券弹窗按钮
        couponBtn: 'Mis recompensas',
        Redeemed: 'Canjeado',
        Issued: 'Emitido',

        // 优惠券提示
        couponTipsA1: '¡Registro exitoso! Regístrate por otros ',
        couponTipsA2: ' días para obtener ',
        couponTipsA3: ' cupón',

        couponTipsB1: '¡Registro exitoso! Regístrate por otros ',
        couponTipsB2: ' días para obtener ',
        couponTipsB3: ' cupón',

        couponTipsC1: 'Felicitaciones por obtener ',
        couponTipsC2: ' cupón.',
        couponTipsC3: '',

        // 错误提示
        code2466: 'Error. Inténtalo de nuevo o comunícate con nosotros.', // 空
        errorTipsA2: '',

        errorTipsB1: '',
        errorTipsB2: '',

        // 已打卡多少天
        hasCheckDayTips1: 'Registrado por ',
        hasCheckDayTips2: ' días.',
        //补签失败提示
        errorCheckTips: 'Error de registro de recuperación. Puedes hacer un registro de recuperación cada 24 horas.',

        no_coupon_note: 'Aún no se ha canjeado ninguna recompensa.', // 空

        ShopNow: 'Comprar ahora',

        copy_success1: 'Copiaste el código. Ve a la tienda para usarlo.', // 空

        Close: 'Cerrar',
    },
    ph: {
        gtm_coupon: 'Discount code',
        scoreMs: 'EcoCredits',
        btnMsgWait: 'login', // 登入
        btnMsgReissueSign: 'Make up for check-in', //'补签',
        btnMsgToday: 'Check in', //'签到',
        btnMsgDone1: 'Checked in', //'已签到',
        btnMsgDone2: 'Rechecked in', //'已补签',
        btnMsgExpire: 'Expired', //'已过期',
        dayAfter: '',
        today: 'Today',
        day1: 'Mon',
        day2: 'Tue',
        day3: 'Wed',
        day4: 'Thu',
        day5: 'Fri',
        day6: 'Sat',
        day7: 'Sun',

        // 没有登录时的提示语
        noLoginTips1: 'Please ',
        noLoginTipsLink1: ' log in ',
        noLoginTips2: ' before check-in.',
        noLoginTipsLink2: 'Check-in Rules', //'打卡细则',

        // 已登录时的提示语
        loginScore1: 'EcoCredits Claimed: ',

        // 签到成功，再签到X天，就能获XX积分了
        pointTipsA1: 'Check-in successful! Check in for another ',
        pointTipsA2: ' days for ',
        pointTipsA3: ' EcoCredits!',

        // 积分不够
        pointTipsB1: 'Insufficient EcoCredits! Find out how to earn more.',

        // code的提示语
        code2452: '', //'今天已打过卡了',
        code2453: '', //'重复点击打卡按钮',
        code2454: '', //'如果补签消耗的积分不够',
        code2455: 'Make-up check-in failed. You have reached the maximum number of make-up check-ins.', //'补签失败，你已达最大补签次数。',
        code2457: 'You have reached the maximum EcoCredits availeble. Thank you for participating!', //'你已达可获取的积分上限值，感谢你的参与。',
        codeFail: 'Make-up check-in failed. Please try again or contact us.', //'补签失败，请重新尝试或Contact Us。',

        // 你已连续打卡a天，恭喜你获得X积分。
        successLongA1: 'You have checked in consecutively for ',
        successLongA2: ' days. Congratulations on earning ',
        successLongA3: ' EcoCredits.', // 您获得了 xx 积分！
        // 你已打卡a天，恭喜你获得X积分。
        successLongB1: 'You have checked in for ',
        successLongB2: ' days. Congratulations on earning ',
        // 你已达可获取的积分上限值，感谢你的参与。
        successLongC2: 'You have reached the maximum EcoCredits availeble. Thank you for participating!',
        successLongC3: 'You have reached the maximum coupons available. Thank you for participating!',
        // 补签成功，恭喜你获得XX积分。
        successSortA1: 'Make-up check-in successful! Congratulations on earning ',
        // 签到成功，恭喜你获得XX积分。
        successSortB1: 'Check-in successful! Congratulations on earning ', // 恭喜
        // 签到成功。
        successSortC: 'Check-in successful!',
        // 暂未到签到时间
        errorTime: 'Check-in not available.',

        // 优惠券弹窗按钮
        couponBtn: 'My Rewards',
        Redeemed: 'Redeemed',
        Issued: 'Issued',

        // 优惠券提示
        couponTipsA1: 'Check-in successful! Check in for another ',
        couponTipsA2: ' days for ',
        couponTipsA3: ' coupon!',

        couponTipsB1: 'Check-in successful! Check in for another ',
        couponTipsB2: ' days for ',
        couponTipsB3: ' coupon!',

        couponTipsC1: 'Congratulations on earning ',
        couponTipsC2: ' coupon.',
        couponTipsC3: '',

        // 错误提示
        code2466: 'Failed, please try again or Contact Us.',
        errorTipsA2: '',

        errorTipsB1: '',
        errorTipsB2: '',

        // 已打卡多少天
        hasCheckDayTips1: 'Checked in for ',
        hasCheckDayTips2: ' days.',
        //补签失败提示
        errorCheckTips: 'Make-up check-in failed. You can do make-up check-in once every 24 hours.',

        no_coupon_note: 'No rewards redeemed yet.',

        ShopNow: 'Shop Now',

        copy_success1: 'You have copied the code, please go to the store to use it.',

        Close: 'Close',
    },
    nl: {
        gtm_coupon: 'Kortingscode',
        scoreMs: 'EcoCredits',
        btnMsgWait: 'login', // 登入
        btnMsgReissueSign: 'Compensatie voor check-in', //'补签',
        btnMsgToday: 'Inchecken', //'签到',
        btnMsgDone1: 'Ingecheckt', //'已签到',
        btnMsgDone2: 'Opnieuw ingecheckt', //'已补签',
        btnMsgExpire: 'Verlopen', //'已过期',
        dayAfter: '',
        today: 'Vandaag',
        day1: 'Ma',
        day2: 'Di',
        day3: 'Wo',
        day4: 'Do',
        day5: 'Vrij',
        day6: 'Za',
        day7: 'Zon',

        // 没有登录时的提示语
        noLoginTips1: 'Gelieve ',
        noLoginTipsLink1: ' in te loggen ',
        noLoginTips2: ' voordat u incheckt.',
        noLoginTipsLink2: 'Incheckregels', //'打卡细则',

        // 已登录时的提示语
        loginScore1: 'EcoCredits opgeëist: ',

        // 签到成功，再签到X天，就能获XX积分了
        pointTipsA1: 'Inchecken gelukt! Inchecken voor andere ',
        pointTipsA2: ' dagen voor ',
        pointTipsA3: ' EcoCredits!',

        // 积分不够
        pointTipsB1: 'Onvoldoende EcoCredits! Ontdek hoe u meer kunt verdienen.',

        // code的提示语
        code2452: '', //'今天已打过卡了',
        code2453: '', //'重复点击打卡按钮',
        code2454: '', //'如果补签消耗的积分不够',
        code2455: 'Compensatie check-in mislukt. U hebt het maximale aantal beschikbare compensatie check-ins bereikt.', //'补签失败，你已达最大补签次数。',
        code2457: 'U hebt het maximale aantal beschikbare EcoCredits bereikt. Bedankt voor uw deelname!', //'你已达可获取的积分上限值，感谢你的参与。',
        codeFail: 'Compensatie check-in mislukt. Probeer het opnieuw of neem contact op met ons op.', //'补签失败，请重新尝试或Contact Us。',

        // 你已连续打卡a天，恭喜你获得X积分。
        successLongA1: 'U hebt gedurende ',
        successLongA2: ' dagen achtereenvolgens ingecheckt. Gefeliciteerd met het verdienen van ',
        successLongA3: ' EcoCredits.', // 您获得了 xx 积分！
        // 你已打卡a天，恭喜你获得X积分。
        successLongB1: 'U hebt gedurende ',
        successLongB2: ' dagen achtereenvolgens ingecheckt. Gefeliciteerd met het verdienen van ',
        // 你已达可获取的积分上限值，感谢你的参与。
        successLongC2: 'U hebt het maximale aantal beschikbare EcoCredits bereikt. Bedankt voor uw deelname!',
        // 你已达可获取的优惠券上限值，感谢你的参与。
        successLongC3: 'U hebt het maximale aantal coupons bereikt dat je kunt verkrijgen. Bedankt voor je deelname.',
        // 补签成功，恭喜你获得XX积分。
        successSortA1: 'Compensatie check-in gelukt! Gefeliciteerd met het verdienen van ',
        // 签到成功，恭喜你获得XX积分。
        successSortB1: 'Inchecken gelukt! Gefeliciteerd met het verdienen van ', // 恭喜
        // 签到成功。
        successSortC: 'Inchecken gelukt!',
        // 暂未到签到时间
        errorTime: 'Inchecken niet beschikbaar.',

        // 优惠券弹窗按钮
        couponBtn: 'Mijn beloningen',
        Redeemed: 'Ingewisseld',
        Issued: 'Uitgegeven',

        // 优惠券提示
        couponTipsA1: 'Inchecken gelukt! Inchecken voor andere ',
        couponTipsA2: ' dagen voor ',
        couponTipsA3: ' een kortingsbon!',

        couponTipsB1: 'Inchecken gelukt! Inchecken voor andere ',
        couponTipsB2: ' dagen voor ',
        couponTipsB3: ' een kortingsbon!',

        couponTipsC1: 'Gefeliciteerd met het verdienen van ',
        couponTipsC2: ' van een kortingsbon.',
        couponTipsC3: '',

        // 错误提示
        code2466: 'Het is mislukt, probeer het opnieuw of neem contact op met ons op.',
        errorTipsA2: '',

        errorTipsB1: '',
        errorTipsB2: '',

        // 已打卡多少天
        hasCheckDayTips1: 'Ingecheckt gedurende ',
        hasCheckDayTips2: ' dagen achtereenvolgens ingecheckt.',
        //补签失败提示
        errorCheckTips: 'Compensatie check-in mislukt. U kunt elke 24 uur een compensatie check-in doen.',

        no_coupon_note: 'De beloningen zijn nog niet ingewisseld.',

        ShopNow: 'Shop nu',

        copy_success1: 'U hebt de code gekopieerd, ga naar de winkel om deze te gebruiken.',

        Close: 'Sluiten',
    },
};
